import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  membershipData: null
};

const kitchenMembershipSlice = createSlice({
  name: "membership",
  initialState,
  reducers: {
    setMembershipData: (state, action) => {
      state.membershipData = action.payload;
    },
    clearMembershipData: (state) => {
      state.membershipData = null;
    }
  }
});

export const { setMembershipData, clearMembershipData } = kitchenMembershipSlice.actions;

export default kitchenMembershipSlice.reducer;
